/**
 * Who scrolls the page (polish 4). The shell is viewport-locked: inside MainLayout, <main>
 * (#shell-main) owns the content's scrolling, not the window. A page rendered alone (a test, a
 * route outside the shell) has no such element, and the window scrolls as before.
 */
export const SHELL_MAIN_ID = 'shell-main';

/** The shell's <main>, or null outside the shell. */
export const shellScroller = () => (typeof document === 'undefined' ? null : document.getElementById(SHELL_MAIN_ID));

/** How far the content is scrolled. */
export function shellScrollTop() {
  const el = shellScroller();
  if (el) return el.scrollTop || 0;
  return typeof window === 'undefined' ? 0 : (window.scrollY || window.pageYOffset || 0);
}

/** Scroll the content to `top` (px). */
export function shellScrollTo(top, { smooth = false } = {}) {
  const el = shellScroller();
  if (el) {
    if (typeof el.scrollTo === 'function') el.scrollTo({ top, behavior: smooth ? 'smooth' : 'auto' });
    else el.scrollTop = top;
    return;
  }
  if (typeof window === 'undefined' || typeof window.scrollTo !== 'function') return;
  if (smooth) window.scrollTo({ top, behavior: 'smooth' });
  else window.scrollTo(0, top);
}
